// src/components/ModalMudarclienteWifi.jsx
import React, { useEffect, useState } from "react";
import "./ModalAgregarCliente.css";
import { authFetch } from "../utils/authFetch";

export default function ModalMudarClienteWifi({ cliente, onClose, onGuardar }) {
  const [planes, setPlanes] = useState([]);

  const [form, setForm] = useState({
    // ✅ ID NUEVO FIBRA (NO precargado)
    id: "",
    // ✅ ID ORIGEN WIFI (oculto)
    cliente_wifi_id: "",

    nombre: "",
    apellidos: "",
    direccion: "",
    telefono: "",
    colonia: "",
    municipio: "",
    plan: "",
    costo: "",
    num_serie: "",
    pppoe_user: "",
    pppoe_pass: "",
    comentario: "",
  });

  function generarPPPoEPass() {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let extra = "";
    for (let i = 0; i < 7; i++) extra += chars[Math.floor(Math.random() * chars.length)];
    return "WF" + extra;
  }

  async function cargarPlanes() {
    try {
      const res = await authFetch("/api/planes/listar");
      const data = await res.json();
      if (data.ok) setPlanes(data.planes);
    } catch (e) {
      console.log("Error cargando planes:", e);
    }
  }

  useEffect(() => {
    cargarPlanes();
    setForm((f) => ({ ...f, pppoe_pass: generarPPPoEPass() }));
  }, []);

  // ✅ Precarga SOLO datos personales + guardar el ID ORIGEN WIFI
  useEffect(() => {
    if (!cliente) return;

    setForm((prev) => ({
      ...prev,
      cliente_wifi_id: String(cliente.id ?? ""), // ✅ origen

      nombre: cliente.nombre ?? "",
      apellidos: cliente.apellidos ?? "",
      direccion: cliente.direccion ?? "",
      telefono: cliente.telefono ?? "",
      colonia: cliente.colonia ?? "",
      municipio: cliente.municipio ?? "",
      comentario: cliente.comentario ?? "",

      // el usuario decide esto al migrar
      plan: "",
      costo: "",

      // NO precargar id nuevo
      id: "",
      pppoe_user: "",
    }));
  }, [cliente]);

  function handleChangeID(e) {
    let value = e.target.value.replace(/\D/g, "");
    const newPPPoE = value ? `user${value}` : "";

    setForm({
      ...form,
      id: value,
      pppoe_user: newPPPoE,
    });
  }

  function actualizarCampo(campo, valor) {
    setForm({ ...form, [campo]: valor });
  }

  function seleccionarPlan(valorPlan) {
    const planSel = planes.find((p) => p.nombre === valorPlan);
    setForm({
      ...form,
      plan: valorPlan,
      costo: planSel ? planSel.costo : "",
    });
  }

  const [instalacionCosto, setInstalacionCosto] = useState(0);
  const [instalacionTipo, setInstalacionTipo] = useState("contado");
  const [instalacionMeses, setInstalacionMeses] = useState(1);

  function guardar() {
    // ✅ obligatorios (agrega los que quieras)
    if (!form.cliente_wifi_id) {
      alert("No se detectó el cliente WiFi de origen.");
      return;
    }
    if (!form.id || !form.nombre || !form.apellidos || !form.plan) {
      alert("Completa los campos obligatorios.");
      return;
    }

    const payload = {
      ...form, // ✅ incluye cliente_wifi_id oculto
      instalacion: {
        costo: Number(instalacionCosto),
        tipo: instalacionTipo,
        meses: instalacionTipo === "contado" ? 1 : instalacionMeses,
      },
    };

    onGuardar(payload);
  }

  // Un cliente elige un NIVEL DE SERVICIO, no la fila de un nodo. Como
  // `clientes.plan` guarda el nombre y la OLT resuelve el resto al
  // autorizar, aquí se muestra cada nombre una sola vez: con dos nodos
  // habría cinco planes repetidos y ninguna forma de distinguirlos.
  // (Supone que un mismo nombre cuesta igual en los dos nodos; si algún
  // día dejan de costar lo mismo, esto hay que repensarlo.)
  const planesUnicos = planes.filter(
    (p, i) => planes.findIndex((q) => q.nombre === p.nombre) === i
  );

  return (
    <div className="modal-backdrop-cliente">
      <div className="modal-cliente">
        <h2>Mudar de cliente WIFI a FIBRA</h2>

        <div className="form-grid">
          <input placeholder="ID Cliente" value={form.id} onChange={handleChangeID} />

          <input placeholder="PPPoE User (auto)" value={form.pppoe_user} readOnly />

          <input
            placeholder="PPPoE Pass"
            value={form.pppoe_pass}
            onChange={(e) => actualizarCampo("pppoe_pass", e.target.value)}
          />

          <input
            placeholder="Nombre"
            value={form.nombre}
            onChange={(e) => actualizarCampo("nombre", e.target.value)}
          />

          <input
            placeholder="Apellidos"
            value={form.apellidos}
            onChange={(e) => actualizarCampo("apellidos", e.target.value)}
          />

          {/* ✅ DIRECCIÓN (NUEVO) */}
          <input
            placeholder="Dirección"
            value={form.direccion}
            onChange={(e) => actualizarCampo("direccion", e.target.value)}
          />

          <input
            placeholder="Teléfono"
            value={form.telefono}
            onChange={(e) => actualizarCampo("telefono", e.target.value)}
          />

          <input
            placeholder="Colonia"
            value={form.colonia}
            onChange={(e) => actualizarCampo("colonia", e.target.value)}
          />

          <input
            placeholder="Municipio"
            value={form.municipio}
            onChange={(e) => actualizarCampo("municipio", e.target.value)}
          />

          <select value={form.plan} onChange={(e) => seleccionarPlan(e.target.value)}>
            <option value="">Seleccione un plan...</option>
            {planesUnicos.map((p) => (
              <option key={p.id} value={p.nombre}>
                {p.nombre} - ${p.costo}
              </option>
            ))}
          </select>

          <input placeholder="Costo" type="number" value={form.costo} readOnly />

          <input
            placeholder="Número de Serie ONU"
            value={form.num_serie}
            onChange={(e) => actualizarCampo("num_serie", e.target.value)}
          />
        </div>

        <textarea
          placeholder="Comentario"
          value={form.comentario}
          onChange={(e) => actualizarCampo("comentario", e.target.value)}
        />

        <h3 style={{ marginTop: "20px" }}>Instalación</h3>

        <div className="form-grid">
          <input
            type="number"
            placeholder="Costo instalación"
            value={instalacionCosto}
            onChange={(e) => setInstalacionCosto(e.target.value)}
          />

          <select value={instalacionTipo} onChange={(e) => setInstalacionTipo(e.target.value)}>
            <option value="contado">Contado</option>
            <option value="meses">Meses sin intereses</option>
          </select>

          {instalacionTipo === "meses" && (
            <select
              value={instalacionMeses}
              onChange={(e) => setInstalacionMeses(Number(e.target.value))}
            >
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={n}>
                  {n} mes(es)
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="modal-buttons">
          <button className="btn-cancelar" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn-guardar" onClick={guardar}>
            Guardar Cliente
          </button>
        </div>
      </div>
    </div>
  );
}

